import Duck from 'extensible-duck';
import { createSelector } from 'reselect';

var selectors = function selectors() {
  return {
    links: new Duck.Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.links;
      };
    }),
    getSocialLinks: new Duck.Selector(function (selectors) {
      return createSelector(selectors.links, function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
          links = _ref.links;
        return links.filter(function (link) {
          return link.type !== 'standard';
        });
      });
    }),
    getLoading: new Duck.Selector(function (selectors) {
      return createSelector(selectors.links, function (_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2,
          loading = _ref2.loading;
        return loading;
      });
    })
  };
};

export { selectors as default };
//# sourceMappingURL=selectors.js.map
